import { render } from "./ProfileWorkbookResult.vue?vue&type=template&id=6d6c2b36"
import script from "./ProfileWorkbookResult.vue?vue&type=script&lang=js"
export * from "./ProfileWorkbookResult.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__